import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Navigation');

export const navigate = createAction('Navigate');
